<fc-signup-completed [error]="error$ | async" (actionButtonClicked)="retry()"></fc-signup-completed>
